import React from "react"
import WingsCardContainer from "./WingsCardContainer"
import WingsCardDetail from "./WingsCardDetail"
import { useIntl } from "react-intl"

const WingsSchoolCard = ({
  img,
  title,
  slug,
  city,
  state,
  acceptanceRate,
  enrolledCount,
  objectID,
  contentType = "schools",
}) => {
  const { formatMessage } = useIntl()
  const locationString = `${city || ""}${(city && state) ? ", " : ""}${state || ""}`

  return (
    <WingsCardContainer
      imageUrl={img || "https://imgix.cosmicjs.com/8cbd9150-6568-11eb-8120-dfe8ec2b682f-campus-centered.jpg"}
      imageAlt={title ? `image of ${title}` : 'School image'}
      title={title}
      to={`/school/${slug}`}
      subtitle={locationString}
      objectID={objectID}
      slug={slug}
      contentType={contentType}
    >
      {(enrolledCount || acceptanceRate) && (
        <div className="w-flex w-flex-column w-justify-start w-items-start w-gap-xs">
          {enrolledCount && (
            <WingsCardDetail
              label={formatMessage({id: "school-card-students", defaultMessage:"Students"})}
              value={enrolledCount.toLocaleString('en-US')}
            />
          )}
          {acceptanceRate && (
            <WingsCardDetail
              label={formatMessage({id: "school-card-acceptance", defaultMessage:"Acceptance"})}
              value={`${Math.round(acceptanceRate)}%`}
            />
          )}
        </div>
      )}
    </WingsCardContainer>
  )
}

export default WingsSchoolCard
